export default {"src":"/_next/static/media/telegram_icon.6bd461a5.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};